import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import type { GuardiaoAnalise } from '@/types/agentesIa';

interface GuardiaoResultadoResponse {
  success: boolean;
  data: GuardiaoAnalise | null;
}

export function useGuardiaoResultado(
  empresaId: number | undefined,
  licitacaoId: number | undefined,
  refreshKey?: string
) {
  return useQuery<GuardiaoAnalise | null>({
    queryKey: ['guardiao-disputa-resultado', empresaId, licitacaoId, refreshKey],
    queryFn: async () => {
      const response = await api.get<GuardiaoResultadoResponse>(
        `/empresas/${empresaId}/guardiao-disputa`,
        { params: { licitacaoId } }
      );
      return response.data;
    },
    enabled: Boolean(empresaId && licitacaoId),
  });
}
